var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.125C0.5 0.826631 0.618526 0.540483 0.829505 0.329505C1.04048 0.118526 1.32663 0 1.625 0H14.375C14.6734 6.28765e-09 14.9595 0.118526 15.1705 0.329505C15.3815 0.540483 15.5 0.826631 15.5 1.125C15.5 1.42337 15.3815 1.70952 15.1705 1.9205C14.9595 2.13147 14.6734 2.25 14.375 2.25H1.625C1.32663 2.25 1.04048 2.13147 0.829505 1.9205C0.618526 1.70952 0.5 1.42337 0.5 1.125V1.125ZM3.5 5.625C3.5 5.32663 3.61853 5.04048 3.8295 4.8295C4.04048 4.61853 4.32663 4.5 4.625 4.5H11.375C11.6734 4.5 11.9595 4.61853 12.1705 4.8295C12.3815 5.04048 12.5 5.32663 12.5 5.625C12.5 5.92337 12.3815 6.20952 12.1705 6.4205C11.9595 6.63147 11.6734 6.75 11.375 6.75H4.625C4.32663 6.75 4.04048 6.63147 3.8295 6.4205C3.61853 6.20952 3.5 5.92337 3.5 5.625ZM6.875 9C6.57663 9 6.29048 9.11853 6.0795 9.32951C5.86853 9.54048 5.75 9.82663 5.75 10.125C5.75 10.4234 5.86853 10.7095 6.0795 10.9205C6.29048 11.1315 6.57663 11.25 6.875 11.25H9.125C9.42337 11.25 9.70952 11.1315 9.9205 10.9205C10.1315 10.7095 10.25 10.4234 10.25 10.125C10.25 9.82663 10.1315 9.54048 9.9205 9.32951C9.70952 9.11853 9.42337 9 9.125 9H6.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingIcon);
export default __webpack_public_path__ + "static/media/sortingIcon.f564512b56cd4c2e474dc91354d96489.svg";
export { ForwardRef as ReactComponent };